export const Types = {
  GET_REQUEST: 'newspaper/GET_REQUEST',
  GET_SUCCESS: 'newspaper/GET_SUCCESS',
};

const INITIAL_STATE = {
  newspaper: {},
  editions: [],
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET_REQUEST:
      return { ...state, loading: true };
    case Types.GET_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return {
        newspaper: action.payload.data[0],
        editions: action.payload.data,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export const Creators = {
  getNewspaperRequest: id => ({ type: Types.GET_REQUEST, id }),
  getNewspaperSuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: { data },
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/newspaper.js